import { render, staticRenderFns } from "./electric.vue?vue&type=template&id=59d52eb2&scoped=true&"
import script from "./electric.vue?vue&type=script&lang=js&"
export * from "./electric.vue?vue&type=script&lang=js&"
import style0 from "./electric.vue?vue&type=style&index=0&id=59d52eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d52eb2",
  null
  
)

export default component.exports